export const windowGlobal = typeof window !== 'undefined' && window;
export const minWidthTable = windowGlobal.innerWidth >= 768;
